import { CertificateRequestContent } from './certificateRequestContent';
import { CertificateRequestAuthorization } from './certificateRequestAuthorization';

export class CertificateRequest {
    authorization: CertificateRequestAuthorization;
    content: CertificateRequestContent;

    public constructor() {
        this.authorization = {
            token: '',
            requestLinkId: '',
            verificationCode: '',
            isTokenAuth: false
        };
        this.content = {
            exportPassword: '',
            fileName: '',
            fileBase64Value: '',
            isCertSignRequest: false
        };
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/models/certificates/certificateRequest.ts